<template>
  <div class="container-overall-invoice">
    <v-alert color="#D3EAFD" class="invoice-box color--info" outlined border="left">
      <div class="invoice-box-header">
        <div class="txt-title">
          {{ $t('invoice.all_invoice') }}
        </div>
        <div class="count-invoice">
          {{ totalInvoice?.countInvoice || 0 }} {{ $t('invoice.title') }}
        </div>
      </div>
      <div class="invoice-box-body">
        <div class="txt-total">{{ $t('payment.total') }}: <span class="txt-total-value">
          {{ totalInvoice.value  | currencySuffixTextThEn(tabType) }}</span></div>
      </div>
    </v-alert>
    <v-alert color="#E8F5E9" class="invoice-box color--success" outlined border="left">
      <div class="invoice-box-header">
        <div class="txt-title">
          {{ $t('payment.paid') }}
        </div>
        <div class="count-invoice">
          {{ totalInvoicePaid.countInvoice }} {{ $t('invoice.title') }}
        </div>
      </div>
      <div class="invoice-box-body">
        <div class="txt-total">{{ $t('payment.total') }}: <span class="txt-total-value">{{ totalInvoicePaid.value | currencySuffixTextThEn(tabType) }}</span></div>
      </div>
    </v-alert>
    <v-alert color="#FFEBEE" class="invoice-box color--danger" outlined border="left">
      <div class="invoice-box-header">
        <div class="txt-title">
          {{ $t('payment.pending') }}
        </div>
        <div class="count-invoice">
          {{ totalInvoiceUnpaid.countInvoice }} {{ $t('invoice.title') }}
        </div>
      </div>
      <div class="invoice-box-body">
        <div class="txt-total">{{ $t('payment.total') }}: <span class="txt-total-value">{{ totalInvoiceUnpaid.value | currencySuffixTextThEn(tabType) }}</span></div>
      </div>
    </v-alert>
    <v-alert color="#FFF8E1" class="invoice-box color--warning" outlined border="left">
      <div class="invoice-box-header">
        <div class="txt-title d-flex align-items-center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="warning" small v-bind="attrs" v-on="on" class="me-2">mdi-information</v-icon>
            </template>
            <div>{{ $t('invoice.this_card_will_not_be_calculated') }}</div>
          </v-tooltip>
          <div>{{ $t('invoice.in_editing') }}</div>
        </div>
        <div class="count-invoice">
          {{ totalInvoicePending.countInvoice }} {{ $t('invoice.title') }}
        </div>
      </div>
      <div class="invoice-box-body">
        <div class="txt-total">{{ $t('payment.total') }}: <span class="txt-total-value">{{ totalInvoicePending.value | currencySuffixTextThEn(tabType) }}</span></div>
      </div>
    </v-alert>
    <v-alert color="#EEEEEE" class="invoice-box color--grey" outlined border="left">
      <div class="invoice-box-header">
        <div class="txt-title">
          {{ $t('bill.cancel') }}
        </div>
        <div class="count-invoice">
          {{ totalInvoiceCancelled.countInvoice }} {{ $t('invoice.title') }}
        </div>
      </div>
      <div class="invoice-box-body">
        <div class="txt-total">{{ $t('payment.total') }}: <span class="txt-total-value">{{ totalInvoiceCancelled.value | currencySuffixTextThEn(tabType) }}</span></div>
      </div>
    </v-alert>
    <v-alert color="#b3b3b3" class="invoice-box color--darkGrey" outlined border="left">
      <div class="invoice-box-header">
        <div class="txt-title">
          {{ $t('bill.bad_debt') }}
        </div>
        <div class="count-invoice">
          {{ totalInvoiceBadDebt.countInvoice }} {{ $t('invoice.title') }}
        </div>
      </div>
      <div class="invoice-box-body">
        <div class="txt-total">{{ $t('payment.total') }}: <span class="txt-total-value">{{ totalInvoiceBadDebt.value | currencySuffixTextThEn(tabType) }}</span></div>
      </div>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'CardInvoiceOverAll',
  props: {
    invoices: {
      type: Array,
      required: true
    },
    tabType: {
      type: String,
      default: 'THB'
    }
  },
  computed: {
    totalInvoice() {
      let obj = {
        value: 0,
        countInvoice: 0
      }
      this.invoices.forEach(item => {
        if((item.currencyCode == this.tabType) || (!item.currencyCode && this.$globalCurrencyCode)){
          obj.value += item.totalValue;
          obj.countInvoice++;
        }
      });
      return obj;
    },
    totalInvoicePaid() {
      let obj = {
        value : 0,
        countInvoice : 0,
      }
      this.invoices.forEach(item => {
        if((item.currencyCode == this.tabType) || (!item.currencyCode && this.$globalCurrencyCode)){
          if(item.isPaid && item.isSent){
            obj.value += item.totalPaidValue;
            obj.countInvoice++;
          }
        }
      });
      return obj;
    },
    totalInvoicePending() {
      let obj = {
        value : 0,
        countInvoice : 0
      }
      this.invoices.forEach(item => {
        if((item.currencyCode == this.tabType) || (!item.currencyCode && this.$globalCurrencyCode)){
          if(!item.isSent && !item.isCancelled){
            obj.value += item.totalValue;
            obj.countInvoice++;
          }
        }
      });
      return obj;
    },
    totalInvoiceUnpaid() {
      let obj = {
        value : 0,
        countInvoice : 0,
      }
      this.invoices.forEach(item => {
        if((item.currencyCode == this.tabType) || (!item.currencyCode && this.$globalCurrencyCode)){
          if(!item.isPaid && item.isSent && !item.isBadDebt){
            obj.value += item.totalValue;
            obj.countInvoice++;
          }
        }
      });
      return obj;
    },
    totalInvoiceCancelled() {
      let obj = {
        value : 0,
        countInvoice : 0,
      }
      this.invoices.forEach(item => {
        if((item.currencyCode == this.tabType) || (!item.currencyCode && this.$globalCurrencyCode)){
          if(item.isCancelled){
            obj.value += item.totalValue;
            obj.countInvoice++;
          }
        }
      });
      return obj;
    },
    totalInvoiceBadDebt() {
      let obj = {
        value : 0,
        countInvoice : 0,
      }
      this.invoices.forEach(item => {
        if((item.currencyCode == this.tabType) || (!item.currencyCode && this.$globalCurrencyCode)){
          if(item.isBadDebt){
            obj.value += item.totalValue;
            obj.countInvoice++;
          }
        }
      });
      return obj;
    }
  },
}
</script>

<style lang="scss">
  .container-overall-invoice{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    padding: 20px;
    @media (max-width: 1024px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 768px) {
      grid-template-columns: repeat(1, 1fr);
    }
    .invoice-box{
      margin: 0;
      padding: 0 0 0 7px;
      .invoice-box-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding : 10px;
        border-top-right-radius: 2px;
        .txt-title{
          font-size: 18px;
          font-weight: 400;
          color: #424242;
        }
        .count-invoice{
          font-weight: bold;
        }
      }
      .invoice-box-body{  
        padding : 10px;
        .txt-total{
          font-size: 16px;
          font-weight: 400;
          color: #424242;
        }
        .txt-total-value{
          color: #47BD82;
        }
        .detail-rc{
          font-size: 14px;
          font-weight: 400;
          color: #424242;
          margin-top: 10px;
          ol{
            margin-left: 10px;
            padding-left: 10px;
            li{
              list-style-type: disc;
            }
          }
        }
      }

      &.color--info{
        // border-left: 7px solid #029CE5;
        .v-alert__border{
          border-color: #029CE5 !important;
          opacity: 1;
        }
        & .invoice-box-header{
          background-color: #D3EAFD;
          & .count-invoice{
            color: #424242;
          }
        }
        & .txt-total-value{
          color: #029CE5;
        }
      }

      &.color--success{
        // border-left: 7px solid #47BD82;
        border-top: 1px solid #E8F5E9;
        border-bottom: 1px solid #E8F5E9;
        border-right: 1px solid #E8F5E9;
        .v-alert__border{
          border-color: #47BD82 !important;
          opacity: 1;
        }
        & .invoice-box-header{
          background-color: #E8F5E9;
          & .count-invoice{
            color: #47BD82;
          }
        }
        & .txt-total-value{
          color: #47BD82;
        }
      }

      &.color--warning{
        // border-left: 7px solid #FBAE43;
        border-top: 1px solid #FFF8E1;
        border-bottom: 1px solid #FFF8E1;
        border-right: 1px solid #FFF8E1;
        .v-alert__border{
          border-color: #FBAE43 !important;
          opacity: 1;
        }
        & .invoice-box-header{
          background-color: #FFF8E1;
          & .count-invoice{
            color: #FBAE43;
          }
        }
        & .txt-total-value{
          color: #FBAE43;
        }
      }

      &.color--danger{
        // border-left: 7px solid #EB5455;
        border-top: 1px solid #FFEBEE;
        border-bottom: 1px solid #FFEBEE;
        border-right: 1px solid #FFEBEE;
        .v-alert__border{
          border-color: #EB5455 !important;
          opacity: 1;
        }
        & .invoice-box-header{
          background-color: #FFEBEE;
          & .count-invoice{
            color: #EB5455;
          }
        }
        & .txt-total-value{
          color: #EB5455;
        }
      }

      &.color--grey{
        border-top: 1px solid #EEEEEE !important;
        border-bottom: 1px solid #EEEEEE !important;
        border-right: 1px solid #EEEEEE !important;
        .v-alert__border{
          border-color: #A9A9A9 !important;
          opacity: 1;
        }
        & .invoice-box-header{
          background-color: #EEEEEE;
          & .count-invoice{
            color: #424242;
          }
        }
        & .txt-total-value{
          color: #424242;
        }
      }

      &.color--darkGrey{
        border-top: 1px solid #b3b3b3 !important;
        border-bottom: 1px solid #b3b3b3 !important;
        border-right: 1px solid #b3b3b3 !important;
        .v-alert__border{
          border-color: #424242 !important;
          opacity: 1;
        }
        & .invoice-box-header{
          background-color: #b3b3b3;
          & .count-invoice{
            color: #424242;
          }
        }  
        & .txt-total-value{
          color: #424242;
        }
      }

    }

    .v-alert__border--left{
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
  }
</style>